import React, { useEffect, useState } from 'react';
import fetchWithRetries from '../../Tools/FetchWithRetries';
import GetChoppers from '../Tools/ChoppersGetChoppers';
import GetMotorPositions from '../Tools/ChoppersGetMotorPositions';
import GetCutterHeadPositions from '../Tools/ChoppersGetCutterHeadPositions';
import GetCutterMountingArrangements from '../Tools/ChoppersGetCutterMountingArrangements';
import GetTrimRemovalMethods from '../Tools/ChoppersGetTrimRemovalMethods';
import GetChopperModels from '../Tools/ChoppersGetModels';
import GetChopperModelDuties from '../Tools/ChoppersGetChopperModelDuties';
import GetMaterialTypes from '../Tools/ChoppersGetMaterialTypes';

const ChopperSelectionModal = ({ onClose, onSubmit, componentID }) => {

    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const [choppers, setChoppers] = useState([]);
    const [motorPositions, setMotorPositions] = useState([]);
    const [cutterHeadPositions, setCutterHeadPositions] = useState([]);
    const [cutterMountingArrangements, setCutterMountingArrangements] = useState([]);
    const [trimRemovalMethods, setTrimRemovalMethods] = useState([]);
    const [chopperModels, setChopperModels] = useState([]);
    const [chopperModelDuties, setChopperModelDuties] = useState([]);
    const [materialTypes, setMaterialTypes] = useState([]);

    // Get Chopper List
    useEffect(() => {

        fetchWithRetries(3, GetChoppers, (payload) => {
            let myChoppers = JSON.parse(payload).data;

            let chopperList = myChoppers.map(c => (
                {
                    ChopperID: c[0],
                    ChopperName: c[1],
                    CreatedByID: c[2],
                    CreatedByFirstName: c[3],
                    CreatedByLastName: c[4],
                    CreatedByUserName: c[5],
                    CreatedByEmail: c[6],
                    CreatedDate: c[7],
                    ModifiedDate: c[8],
                    ChopperModelID: c[9],
                    ChopperModelName: c[10],
                    ChopperModelManufacturerID: c[11],
                    ChopperModelManufacturerName: c[12],
                    ChopperModelAirCapacity: c[13],
                    ChopperModelInletWidth: c[14],
                    ChopperModelMotorHP: c[15],
                    ChopperModelMaxRPM: c[16],
                    ChopperModelLink: c[17],
                    MaterialTypeID: c[18],
                    MaterialTypeName: c[19],
                    MaterialTypeDutyID: c[20],
                    MaterialTypeDutyName: c[21],
                    MotorPositionID: c[22],
                    MotorPositionLetter: c[23],
                    MotorPositionDescription: c[24],
                    MotorPositionPath: c[25],
                    CutterHeadPositionID: c[26],
                    CutterHeadPositionLetter: c[27],
                    CutterHeadPositionDescription: c[28],
                    CutterHeadPositionPath: c[29],
                    CutterMountingArrangementID: c[30],
                    CutterMountingArrangementLetter: c[31],
                    CutterMountingArrangementDescription: c[32],
                    CutterMountingArrangementPath: c[33],
                    TrimRemovalMethodID: c[34],
                    TrimRemovalMethodLetter: c[35],
                    TrimRemovalMethodDescription: c[36],
                    TrimRemovalMethodPath: c[37],
                    MaterialThickness: c[38],
                    MaterialSpeed: c[39],
                    MaterialWidth: c[40],
                    InletDiameter: c[41],
                    AirflowThroughCutter: c[42],
                    BladesInCutter: c[43],
                    DesiredPieceSize: c[44],
                    CutterRotatingSpeed: c[45],
                    PressureLoss: c[46],
                    Knives: c[47],
                    Bearings: c[48],
                    OilMist: c[49] == "True" ? "Yes" : "No",
                    TrimGeneratedBy: c[50],
                    PaintColor: c[51],
                    Voltage: c[52],
                    Flywheel: c[53] == "True" ? "Yes" : "No",
                    TrimsPerMachine: c[54],
                    NumberOfMachines: c[55],
                    PaperGrades: c[56],
                    Notes: c[57]
                }
            ));
            setChoppers(chopperList);
        });

    }, []);

    // Get Motor Positions
    useEffect(() => {

        fetchWithRetries(3, GetMotorPositions, (payload) => {

            let myMotorPositions = JSON.parse(payload).data;

            let motorPositionsList = myMotorPositions.map(mp => (
                {
                    "id": mp[0],
                    "Letter": mp[1],
                    "Description": mp[2],
                    "Path": mp[3]
                }
            ));

            setMotorPositions(motorPositionsList);

        });

    }, []);

    // Get Cutter Head Positions
    useEffect(() => {

        fetchWithRetries(3, GetCutterHeadPositions, (payload) => {

            let myCutterHeadPositions = JSON.parse(payload).data;

            let cutterHeadPositionsList = myCutterHeadPositions.map(chp => (
                {
                    "id": chp[0],
                    "Letter": chp[1],
                    "Description": chp[2],
                    "Path": chp[3]
                }
            ));

            setCutterHeadPositions(cutterHeadPositionsList);

        });

    }, []);

    // Get Cutter Mounting Arrangements
    useEffect(() => {

        fetchWithRetries(3, GetCutterMountingArrangements, (payload) => {

            let myCutterMountingArrangements = JSON.parse(payload).data;

            let cutterMountingArrangementsList = myCutterMountingArrangements.map(cma => (

                {
                    "id": cma[0],
                    "Letter": cma[1],
                    "Description": cma[2],
                    "Path": cma[3]
                }
            ));

            setCutterMountingArrangements(cutterMountingArrangementsList);

        });

    }, []);

    // Get Trim Removal Methods
    useEffect(() => {

        fetchWithRetries(3, GetTrimRemovalMethods, (payload) => {

            let mytrimRemovalMethods = JSON.parse(payload).data;

            let trimRemovalMethodsList = mytrimRemovalMethods.map(tr => (
                {
                    "id": tr[0],
                    "Letter": tr[1],
                    "Description": tr[2],
                    "Path": tr[3]
                }
            ));

            setTrimRemovalMethods(trimRemovalMethodsList);

        });

    }, []);

    //Get chopper models
    useEffect(() => {

        fetchWithRetries(3, GetChopperModels, (payload) => {

            let myModels = JSON.parse(payload).data;

            let modelList = myModels.map(cm => (
                {
                    id: cm[0],
                    ManufacturerID: cm[1],
                    ManufacturerName: cm[2],
                    ModelName: cm[3],
                    AirCapacity: cm[4],
                    InletWidth: cm[5],
                    MotorHP: cm[6],
                    MaxRPM: cm[7],
                    Link: cm[8],
                    Duty: []
                }
            ));

            setChopperModels(modelList);

        });


    }, []);

    // Get chopper model duties
    useEffect(() => {

        fetchWithRetries(3, GetChopperModelDuties, (payload) => {
            let myChopperModelDuties = JSON.parse(payload).data;

            let chopperModelDutiesList = myChopperModelDuties.map(cmd => (
                {
                    id: cmd[0],
                    ChopperModelID: cmd[1],
                    DutyID: cmd[2],
                    DutyName: cmd[3]
                }
            ));

            setChopperModelDuties(chopperModelDutiesList);

        });

    }, [chopperModels]);

    //Get material types
    useEffect(() => {

        fetchWithRetries(3, GetMaterialTypes, (payload) => {

            let myMaterialTypes = JSON.parse(payload).data;

            let materialTypesList = myMaterialTypes.map(cmt => (

                {
                    MaterialID: cmt[0],
                    MaterialName: cmt[1],
                    DutyID: cmt[2],
                    DutyName: cmt[3]

                }
            ));

            setMaterialTypes(materialTypesList);

        });

    }, []);

    return (
        <>
            {/* Dark background overlay */}
            <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.25)", backdropFilter: "blur(8px)", zIndex: 1040 }} onClick={onClose}></div>

            <div className="modal d-block" style={{ display: "flex", flexDirection: "column", justifyContent: "center", margin: "0px", alignItems: "center" }} tabIndex="-1">
                <div className="modal-dialog" style={{ display: "flex", flexDirection: "column", justifyContent: "center", margin: "auto", alignItems: "center", minWidth: "90vw", marginTop: "5vh" }}>
                    <div className="modal-content" style={{ border: "1px solid var(--bs-secondary)", boxShadow: "4px 4px 4px 0px gray", width: "90vw", height: "90vh" }}>

                        <div className="modal-header" style={{ backgroundColor: "var(--bs-secondary)", color: "var(--bs-light)", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <div style={{ width: "50%", display: "flex", justifyContent: "flex-start" }}><h4 className="modal-title" style={{color: "var(--bs-white)"}}>Chopper Select</h4></div>

                            <button type="button" className="btn-close" onClick={onClose} style={{ backgroundColor: "var(--bs-light)", color: "var(--bs-light)" }}></button>
                        </div>

                        <div className="modal-body" style={{ overflowY: "auto", padding: "4px" }}>

                            <div className="table-responsive" style={{ width: "100%", height: "100%" }}>

                                {/* A table that shows all available data about each chopper, given all the data from the states including rendering images using the path attribute as img src where relevant*/}
                                <table className="table table-bordered" style={{ width: "100%", height: "100%" }}>
                                    <thead>
                                        <tr style={{ backgroundColor: "var(--bs-secondary)", color: "var(--bs-light)" }}>
                                            <th style={{ backgroundColor: "var(--bs-purple)", color: "var(--bs-light)", textAlign: "center", verticalAlign: "middle", width: "10%", border: "2px solid var(--bs-secondary)" }}>Chopper Name</th>
                                            <th style={{ backgroundColor: "var(--bs-purple)", color: "var(--bs-light)", textAlign: "left", verticalAlign: "middle", width: "20%", border: "2px solid var(--bs-secondary)" }}>Specifications</th>
                                            <th style={{ backgroundColor: "var(--bs-purple)", color: "var(--bs-light)", textAlign: "left", verticalAlign: "middle", width: "20%", border: "2px solid var(--bs-secondary)" }}>Material</th>
                                            <th style={{ backgroundColor: "var(--bs-purple)", color: "var(--bs-light)", textAlign: "left", verticalAlign: "middle", width: "30%", border: "2px solid var(--bs-secondary)" }}>Chopper Configuration</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {choppers.map((chopper) => (
                                            <tr key={chopper.ChopperID} style={{ border: "2px solid var(--bs-secondary)" }}>

                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center" }}>
                                                        <b>{chopper.ChopperName}</b>
                                                        ({chopper.ChopperModelManufacturerName} {chopper.ChopperModelName})
                                                        <button type="button" className="btn btn-primary"
                                                            style={{ padding: "4px 8px", marginTop: "4px", width: "100px" }}
                                                            onClick={() => onSubmit(chopper, componentID)}>
                                                            Select
                                                        </button>

                                                    </div>
                                                </td>

                                                <td style={{ textAlign: "left", verticalAlign: "top" }}>
                                                    <table className="table table-sm table-striped table-bordered" >
                                                        <tbody>
                                                            <tr><td><b>Air Capacity</b></td><td>{chopper.ChopperModelAirCapacity} CFM</td></tr>
                                                            <tr><td><b>Pressure Loss</b></td><td>{chopper.PressureLoss}</td></tr>
                                                            <tr><td><b>Chopper Inlet Width</b></td><td>{chopper.ChopperModelInletWidth} in</td></tr>
                                                            <tr><td><b>Motor HP</b></td><td>{chopper.ChopperModelMotorHP}</td></tr>
                                                            <tr><td><b>Max RPM</b></td><td>{Number(chopper.ChopperModelMaxRPM).toLocaleString('en-US')}</td></tr>
                                                            <tr><td><b>System Duct Diameter Into Chopper</b></td><td>{chopper.InletDiameter} in</td></tr>
                                                            <tr><td><b>Airflow Through Cutter</b></td><td>{chopper.AirflowThroughCutter} CFM</td></tr>
                                                            <tr><td><b># Blades in Cutter</b></td><td>{chopper.BladesInCutter}</td></tr>
                                                            <tr><td><b>Cutter Rotating Speed</b></td><td>{chopper.CutterRotatingSpeed} RPM</td></tr>
                                                            <tr><td><b>Knives</b></td><td>{chopper.Knives}</td></tr>
                                                            <tr><td><b>Bearings</b></td><td>{chopper.Bearings}</td></tr>
                                                            <tr><td><b>Oil Mist</b></td><td>{chopper.OilMist}</td></tr>
                                                            <tr><td><b>Trim Generated By</b></td><td>{chopper.TrimGeneratedBy}</td></tr>

                                                        </tbody>
                                                    </table>

                                                </td>

                                                <td style={{ textAlign: "left", verticalAlign: "top" }}>
                                                    <table className="table table-sm table-striped table-bordered">
                                                        <tbody>
                                                            <tr><td><b>Material</b></td><td>{materialTypes.find(mt => mt.MaterialID === chopper.MaterialTypeID)?.MaterialName}</td></tr>
                                                            <tr><td><b>Material Thickness</b></td><td>{chopper.MaterialThickness} in</td></tr>
                                                            <tr><td><b>Material Speed</b></td><td>{chopper.MaterialSpeed} ft/min</td></tr>
                                                            <tr><td><b>Material Width</b></td><td>{chopper.MaterialWidth} in</td></tr>
                                                            <tr><td><b>Desired Piece Size</b></td><td>{chopper.DesiredPieceSize} in</td></tr>
                                                        </tbody>
                                                    </table>

                                                    <table className="table table-sm table-striped table-bordered">
                                                        <tbody>
                                                            <tr><td><b>Paint Color</b></td><td>{chopper.PaintColor}</td></tr>
                                                            <tr><td><b>Voltage</b></td><td>{chopper.Voltage}</td></tr>
                                                            <tr><td><b>Flywheel</b></td><td>{chopper.Flywheel}</td></tr>
                                                            <tr><td><b>Trims Per Machine</b></td><td>{chopper.TrimsPerMachine}</td></tr>
                                                            <tr><td><b>Number of Machines</b></td><td>{chopper.NumberOfMachines}</td></tr>
                                                            <tr><td><b>Paper Grades</b></td><td>{chopper.PaperGrades}</td></tr>
                                                            <tr><td><b>Notes</b></td><td>{chopper.Notes}</td></tr>
                                                        </tbody>
                                                    </table>

                                                </td>

                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center", height: "100%", width: "100%" }}>

                                                        {/* Motor Position */}
                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
                                                            <b>Motor Position</b>
                                                            <img height="auto" width="96px" src={motorPositions.find(mp => mp.id === chopper.MotorPositionID)?.Path} alt={motorPositions.find(mp => mp.id === chopper.MotorPositionID)?.Description} />
                                                            <span>{motorPositions.find(mp => mp.id === chopper.MotorPositionID)?.Description}</span>
                                                        </div>

                                                        {/* Cutter Head Position */}
                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
                                                            <b>Cutter Head Position</b>
                                                            <img height="auto" width="96px" src={cutterHeadPositions.find(chp => chp.id === chopper.CutterHeadPositionID)?.Path} alt={cutterHeadPositions.find(chp => chp.id === chopper.CutterHeadPositionID)?.Description} />
                                                            <span>{cutterHeadPositions.find(chp => chp.id === chopper.CutterHeadPositionID)?.Description}</span>
                                                        </div>

                                                        {/* Cutter Mounting Arrangement */}
                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
                                                            <b>Cutter Mounting Arrangement</b>
                                                            <img height="auto" width="96px" src={cutterMountingArrangements.find(cma => cma.id === chopper.CutterMountingArrangementID)?.Path} alt={cutterMountingArrangements.find(cma => cma.id === chopper.CutterMountingArrangementID)?.Description} />
                                                            <span>{cutterMountingArrangements.find(cma => cma.id === chopper.CutterMountingArrangementID)?.Description}</span>
                                                        </div>

                                                        {/* Trim Removal Method */}
                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
                                                            <b>Trim Removal Method</b>
                                                            <img height="auto" width="96px" src={trimRemovalMethods.find(tr => tr.id === chopper.TrimRemovalMethodID)?.Path} alt={trimRemovalMethods.find(tr => tr.id === chopper.TrimRemovalMethodID)?.Description} />
                                                            <span>{trimRemovalMethods.find(tr => tr.id === chopper.TrimRemovalMethodID)?.Description}</span>
                                                        </div>

                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>


                            </div>

                        </div>

                        <div className="modal-footer" style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                            <div>
                                <button type="button" style={{ margin: "4px" }} className="btn btn-secondary" onClick={onClose}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default ChopperSelectionModal;